/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const whatsAppTemplateParametersDataSchema = z.object({
	parameters: z.array(z.string()),
})

export type WhatsAppTemplateParametersDataSchema = z.infer<typeof whatsAppTemplateParametersDataSchema>
